<template>
	<div>
        <div v-if="search">Catégories de recherche : <b-button v-b-modal="'i-'+ id" variant="link" v-if="categories_checked.length == 0">Toutes les catégories</b-button></div>
        <div :id="'id'+id" :style="tabulator ? 'height:30px' : ''">
            <b-button v-b-modal="'i-'+ id" variant="link">
                <div>
                    <span v-for="(category, idx) in categories_checked" :key="idx">
                        <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name : ""}}</b-badge>&nbsp;
                    </span>
                    <span v-if="!search && categories_checked.length == 0">Pas de catégorie</span>
                </div>
           </b-button>
        </div>  
        <b-modal :title="'Catégories'" size="xl" ok-only :id="'i-'+ id" @shown="setTree" @hidden="open = false;">
            <p>
                <span v-for="(category, idx) in categories_checked" :key="idx">
                    <b-badge variant="primary">{{categories_obj[category] ? categories_obj[category].name : ""}}</b-badge>&nbsp;
                </span>
            </p>

            <Tree :edit="edit" @updateNode="updateNode" id="my-tree-id" ref="tree" :custom-options="categories_options" :custom-styles="categories_styles" :nodes="categories"></Tree>
        </b-modal>      
 	</div>
</template>

<script>
    import database from "../services/database.js";
    import store from "../store";

	import Tree from "../../public/js/vuejs-tree/src/components/Tree.vue";
    import uniqueId from "lodash.uniqueid";
    import { type } from 'case';

    var clone = require("clone");

    export default {
        nme: "categorie_splash",
		components: {
            Tree
		},
		props: {
            source: {},
            column: {},
            index: {},
            tabulator: {
                default: true
            },
            categories_prop: {
                default: null
            },
            edit: true,
            lang: {
                default: "fr"
            },
            search: false,
            params: null
        },
		data() {
			return {
                id: uniqueId(),
                categories_checked: [],
                categories_checked_string: [],
                loaded: 0,
                open: false,
                list: false,

                categories: [],
                categories_obj: {},
                categories_obj_names: {},
                update: false,
                emit_update: false
			};
        },
        computed: {
            categories_styles() {
                return {
                    tree: {
                        height: "auto",
                        maxHeight: "300px",
                        overflowY: "visible",
                        display: "inline-block",
                        textAlign: "left",
                    },
                    row: {
                        style: {
                            width: "500px",
                            cursor: "pointer",
                        },
                        child: {
                            class: "",
                            style: {
                            height: "35px",
                            },
                            active: {
                                style: {
                                    height: "35px",
                                },
                            },
                        },
                    },
                    rowIndent: {
                        paddingLeft: "20px",
                    },
                    text: {
                        // class: "" // uncomment this line to overwrite the 'capitalize' class, or add a custom class
                        style: {},
                        active: {
                            style: {
                                "font-weight": "bold",
                                color: "#2ECC71",
                            },
                        },
                    },
                };
            },
            categories_options() {
                return {
                    treeEvents: {
                        expanded: {
                            state: false,
                        },
                        collapsed: {
                            state: false,
                        },
                        selected: {
                            state: false
                        },
                        checked: {
                            state: true,
                        },
                    },
                    events: {
                        expanded: {
                            state: true,
                        },
                        selected: {
                            state: true,
                        },
                        checked: {
                            state: true
                        },
                        editableName: {
                            state: true,
                            calledEvent: "expanded",
                        },
                    },
                    addNode: {
                        state: false,
                        fn: null,
                        appearOnHover: false,
                    },
                    editNode: { state: false, fn: null, appearOnHover: false },
                    deleteNode: {
                        state: false,
                        fn: null,
                        appearOnHover: true,
                    },
                    showTags: true,
                };
            },
        },
		watch: {
            source() {
                this.update = false;
                this.init();
            },
            categories_checked: {
				deep: true,
				async handler(value, oldValue) {
                    if (this.params && this.params.uniq)
                        var categories_checked_string = this.categories_checked.length > 0 ? this.categories_checked[0] : "";
                    else
                        var categories_checked_string = JSON.stringify(this.categories_checked);
                    if (this.emit_update == true && categories_checked_string != this.categories_checked_string)
                    {                        
                        this.$nextTick(() => {
                            this.$emit('update', this.index, this.column, categories_checked_string);
                        });
                    }
                    this.categories_checked_string = categories_checked_string;
                }
            }
		},
		methods: {
            async setTree()
            {
                //console.log("setTree - " + this.update)
                
                var self = this;
                this.emit_update = false;

                if (this.update == false)
                {
                    this.$refs.tree.uncheckAllNodes();
                    this.$refs.tree.collapseAllNodes();

                    for (var i = 0; i < this.categories_checked.length; i++)
                    {
                        this.$refs.tree.checkNode(this.categories_checked[i]);
                        this.$refs.tree.expandNode(this.categories_checked[i]);
                    }

                    this.update = true;
                }
                
				setTimeout(() => {
                    //console.log("setTree - end")
                    self.emit_update = true;
                }, "200");
            },
            async setCategories()
            {
                //console.log("setCategoriesObj");

                this.categories = [];

                if (this.categories_prop)
                    categories = this.categories_prop;
                else
                {
                    var categories = await database.get("select", "categories", {
                        select: "*"
                    });
                }
                
                const categories_obj = {};

                // Indexation + initialisation des noeuds
                for (let i = 0; i < categories.length; i++) {
                    const cat = categories[i];
                    cat.id = cat.id_cms ? cat.id_cms : cat.id.toString();
                    cat.name = JSON.parse(cat.nom)[this.lang]
                    cat.nodes = [];
                    this.categories_obj[cat.id] = cat;
                    this.categories_obj_names[cat[this.lang]] = cat;
                    categories_obj[cat.id] = cat;
                }

                // Construction de l'arbre
                for (let i = 0; i < categories.length; i++) {
                    const cat = categories[i];
                    const parentId = cat.parent || cat.id_cms_parent;

                    const node = {
                        id: cat.id,
                        parent: parentId || null,
                        text: cat.name,
                        checkable: true,
                        selectable: false,
                        expandable: true,
                        position: cat.position ?? 0,
                        state: {
                            checked: false,
                            expanded: false,
                            selected: false
                        },
                        nodes: cat.nodes
                    };

                    if (!parentId || parentId === "" || !categories_obj[parentId]) {
                        this.categories.push(node);
                    } else {
                        categories_obj[parentId].nodes.push(node);
                    }
                }

                // 🔁 Fonction récursive pour trier tous les niveaux par position
                function sortByPosition(nodes) {
                    nodes.sort((a, b) => (a.position || 0) - (b.position || 0));
                    nodes.forEach(node => {
                        if (node.nodes && node.nodes.length > 0) {
                            sortByPosition(node.nodes);
                        }
                    });
                }

                // Appliquer le tri sur le niveau racine
                sortByPosition(this.categories);

                console.log(this.categories)
            },
            updateNode(node)
            {
                var self = this;

                if (node.state.checked)
                {
                    if (this.params && this.params.uniq)
                    {
                        var categories_checked = this.$refs.tree.getCheckedNodes("id", false);
                        for (var i = 0; i < categories_checked.length; i++)
                        {
                            if (categories_checked[i] != (node.id || node))
                            {
                                this.$refs.tree.uncheckNode(categories_checked[i]);
                            }

                        }
                    }
                    else if (this.params && this.params.parent_categories)
                    {
                        while (node.parent)
                        {
                            if (!this.categories_checked.includes(node.parent))
                            {
                                this.$refs.tree.checkNode(node.parent);
                            }
                            node = this.$refs.tree.findNode(node.parent);
                        }
                    }
                }

                if (this.update == true)
                {
                    this.categories_checked = this.$refs.tree.getCheckedNodes("id", false);
                }
            },
            test()
            {
                //console.log("toto")
            },
            async init()
            {
                //console.log("init")

                var self = this;

                this.emit_update = false;
            
                var source = clone(this.source);

                if (!source)
                    source = [];

                if (typeof source == "string")
                {
                    if (!source.startsWith("["))
                        source = [source];
                    else
                        source = JSON.parse(source);
                }

                this.categories_checked = source;

                /*var categories = store.state.categories;
           
                    <span v-for="(category,      if (!categories)*/
                    await this.setCategories();
                /*else
                {
                    this.categories = categories.categories;
                    this.categories_obj = categories.categories_obj;
                    this.categories_obj_names = categories.categories_obj_names;
                }*/

                //console.log(self.$refs.tree)

                if (self.$refs.tree)
                {
                    this.setTree();
                }
            }
		},
		mounted: async function () {
            this.init();
		},
	};
</script>

<style>
</style>
